import { SUPABASE_URL, SUPABASE_KEY } from './supabase';
import { getActiveOrganisationId } from './activeOrg';

/**
 * Call an Edge Function that validates Auth0 access tokens in code (verify_jwt = false).
 * Do not use sb.functions.invoke — it sends the Auth0 ID token, which the gateway rejects.
 */
export async function invokeAuth0EdgeFunction(functionName, body, getAccessTokenSilently) {
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  if (!audience) {
    throw new Error('Missing REACT_APP_AUTH0_AUDIENCE');
  }
  if (!SUPABASE_URL || !SUPABASE_KEY) {
    throw new Error('Missing Supabase configuration');
  }

  const token = await getAccessTokenSilently({
    authorizationParams: { audience },
  });

  const activeOrgId = getActiveOrganisationId();
  const payload = activeOrgId && body && body.organisation_id === undefined
    ? { ...body, organisation_id: activeOrgId }
    : body;

  const resp = await fetch(`${SUPABASE_URL}/functions/v1/${functionName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      apikey: SUPABASE_KEY,
    },
    body: JSON.stringify(payload),
  });

  let data;
  try {
    data = await resp.json();
  } catch {
    throw new Error(`Edge function returned invalid JSON (${resp.status})`);
  }

  if (!resp.ok) {
    const detail = data?.detail ? `: ${data.detail}` : '';
    throw new Error(data?.error ? `${data.error}${detail}` : `Edge function failed (${resp.status})`);
  }
  if (data?.error) {
    const detail = data.detail ? `: ${data.detail}` : '';
    throw new Error(`${data.error}${detail}`);
  }
  return data;
}
